import { render } from "./Trx.vue?vue&type=template&id=c2ad28bc&scoped=true"
import script from "./Trx.vue?vue&type=script&lang=js"
export * from "./Trx.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Public\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2ad28bc"]])

export default __exports__